// import './LoadingBar.css';
import View from '@components/View';
import ScalableWrapper from '@components/ScalableWrapper';
import {  images, videos } from '@utils/media';
import MainMenuBackground from '@components/MainMenuBackground';
import { LoadingBar } from './LoadingBar';

export const MainMenuLoadingScreen = ({ isVisible, message, percentage }: { isVisible: boolean; message: string; percentage: number }) => {
    return (
        <View className={`flex flex-col items-center justify-center absolute top-0 left-0 w-full h-full bg-transparent overflow-hidden z-50 ${isVisible ? 'opacity-100' : 'opacity-0'}`} enableEventCapturing>
            <MainMenuBackground source={videos.LoadingVideo} placeholder={images.LoadingBackground} />
            <ScalableWrapper maintainAspectRatioBy="height">
                <View className='w-full h-full flex flex-col items-center justify-center translate-y-36'>
                    <View className='flex flex-col items-center justify-center gap-4'>
                        <LoadingBar text={message} percentage={percentage} color="white" loadingBarClassName='!w-72' />
                    </View>
                </View>
            </ScalableWrapper>
        </View>
    );
};